import { changeMode } from "@/store/mode-slice";
import { selectIsProjectEmpty } from "@/store/selections-selectors";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { Theme } from "@emotion/react";
import {
  ArrowRightIcon,
  FaroIconButton,
  FaroText,
  FontWeights,
} from "@faro-lotv/flat-ui";
import { Stack, SxProps } from "@mui/material";
import type { JSX } from "react";

type CrateAreaTitleProps = {
  /** Optional styling applied to the component */
  sx?: SxProps<Theme>;
};

/**
 * @returns a component with a title and a learn more link
 */
export function CrateAreaTitle({ sx }: CrateAreaTitleProps): JSX.Element {
  // If the project is empty, show a button to go back to the start screen.
  const isProjectEmpty = useAppSelector(selectIsProjectEmpty);
  const dispatch = useAppDispatch();

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: "center",
        justifyContent: {
          xs: "center",
          sm: "flex-start",
        },
        borderBottom: ({ palette }) => ({
          sm: `2px solid ${palette.gray100}80`,
        }),
        ...sx,
      }}
    >
      {isProjectEmpty && (
        <FaroIconButton
          aria-label="back to start"
          onClick={() => {
            dispatch(changeMode("start"));
          }}
          sx={{ mb: 0.75 }}
        >
          <ArrowRightIcon
            sx={{
              transform: "rotate(180deg)",
            }}
          />
        </FaroIconButton>
      )}

      <FaroText
        variant="bodyM"
        sx={{ fontWeight: FontWeights.SemiBold, mb: 1 }}
      >
        Project Set Up
      </FaroText>
    </Stack>
  );
}
